<section>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Reports</li>
            <li class="breadcrumb-item active">Vendor Invoices</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><img src="../../../../assets/img/report.png"> Vendor Invoices</span>
                        <div class="float-right">
                            <button pButton (click)="clear(dt2)" label="Clear" class="p-button-raised" icon="pi pi-trash" 
                            style="height: 30px;background-color: aliceblue;color: #1a90d0;"></button>
                        </div>                       
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <form [formGroup]="vendorInvoicesReportForm" novalidate>
    <div class="card">  
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-3">
                            <label for="startDate">Timesheet Start Date<span class="required-field">*</span></label>
                            <p-calendar class="invreportdatepicker" [showIcon]="true" inputId="navigators" formControlName="timesheetStartDate" (onSelect)="onSelectStartDate($event)" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030"></p-calendar>                          
                        </div>
                        <div class="p-field p-col-12 p-md-3">
                            <label for="endDate">Timesheet End Date<span class="required-field">*</span></label>
                            <p-calendar class="invreportdatepicker" [showIcon]="true" inputId="navigators" formControlName="timesheetEndDate" [minDate]="timesheetStartSelectedDate" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030"></p-calendar>                          
                        </div>
                        
                       <div class="p-field p-col-12 p-md-3">
                            <label for="reportType">Report Type</label>
                          
                            <p-dropdown [options]="reportTypes" placeholder="Select"
                            (onChange)="getReportTypesOnChange($event)" [(ngModel)]="selectedReportIds"
                            [ngModelOptions]="{standalone: true}" defaultLabel="Select"
                            optionLabel="description"></p-dropdown>
                        </div> 

                         <div class="p-field-checkbox p-col-12 p-md-3" style="margin-bottom: 0px;">
                            <p-checkbox binary="true" 
            inputId="showIneligibleApplicants" 
            [(ngModel)]="showIneligibleApplicants"
            [ngModelOptions]="{standalone: true}" 
            (onChange)="onChangeShowIneligibleApplicants($event)">
        </p-checkbox>
                                         
                                            <label for="showIneligibleApplicants">Show invoice ineligible applicants</label>
                                        </div> 
                       
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
          <div class="text-center">
            <button class="bg-success" pButton pRipple type="button" [disabled]="!this.vendorInvoicesReportForm.valid" (click) ="generateReport(vendorInvoicesReportForm,dt2)" style="background-color: #1a90d0; color: white;font-weight: bold;"><img src="../../../../assets/img/New-rep.png" width="32px">Generate Report</button>
            
          </div>
        </div>
        <br><br><br>
    </div>
    <br>
    <br>
    </form>
</section>

 <section>
    <div [hidden]="!showTable" class="card">
        <div class="card-header">
           <span class="text-lg font-weight-bold">Invoice Report</span>
           <div class="card-tools">
            <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash"
            (click)="clearFilter(dt2)" style="float: left;height: 30px;"></button>
            <button pButton label="Export" class="p-button-raised  m-2" *ngIf="sharedService.checkPermission('Admin_Export')" (click)="exportVendorInvoiceReport()"
            icon="pi pi-file-excel" type="button" style="height: 30px;"></button>
            <p-multiSelect [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header"  [showHeader] = "false">
                <ng-template let-column pTemplate="item">
                    <div class="column-item">
                        <div>{{column.header}}</div>
                    </div>
                </ng-template>
            </p-multiSelect>
            
        </div>
        </div>
        <div class="card-body" id="page-admin">
            <p-table id="vendorInvoice-report"  #dt2 [value]="vendorInvoicesReportList" [lazy]="true"
                (onLazyLoad)="loadVendorInvoiceList($event)" paginatorDropdownAppendTo="body" dataKey="vendorCompanyName" [rows]="10"
                [showCurrentPageReport]="true" [resizableColumns]="true" columnResizeMode="expand"
                [rowsPerPageOptions]="[10,25,50,100,250,500,1000]" styleClass="p-datatable-gridlines"  [scrollable]="true" scrollHeight="350px"  [responsive]="true"
                [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup [attr.colspan]="selectedColumns.length">
                        <col style="width: 3rem;">
                        <col style="width: 11rem" *ngIf="isShowColumns('vendorCompanyName')">
                        <col style="width: 11rem" *ngIf="isShowColumns('applicantName')">
                        <col style="width: 10rem" *ngIf="isShowColumns('invoiceDate')">
                      
                        <col style="width: 10.5rem" *ngIf="isShowColumns('timesheetStartDate')">
                        <col style="width: 10rem" *ngIf="isShowColumns('timesheetEndDate')">
                        <col style="width: 12rem" *ngIf="isShowColumns('reportStatusName')">
                        <col style="width: 11rem" *ngIf="isShowColumns('statusName')">
                        <col style="width: 15rem" *ngIf="isShowColumns('verifiedWithin24hrsStatus')">
                        <col style="width: 10rem" *ngIf="isShowColumns('verifiedOn')">
                       
                        <col style="width: 11rem;" *ngIf="isShowColumns('invoiceRejectReason')">
                        <col style="width: 11rem" *ngIf="isShowColumns('rejectedByName')">
                        <col style="width: 11rem" *ngIf="isShowColumns('approvedByName')">
                        <col style="width: 11rem" *ngIf="isShowColumns('unableProcessPaymentByName')">
                       
       
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 3rem;" pResizableColumn>#</th>
                        <th *ngIf="isShowColumns('vendorCompanyName')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>Vendor 
                            <span pSortableColumn="vendorCompanyName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="vendorCompanyName" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'vendorCompanyName'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()">
                            </app-basic-filter>
                            </th>
                        <th *ngIf="isShowColumns('applicantName')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>Applicant 
                            <span pSortableColumn="applicantName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="applicantName" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'applicantName'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('invoiceDate')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 10.5rem;" pResizableColumn>Invoice Date
                            <span pSortableColumn="invoiceDate" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="invoiceDate" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-date-filter [field]="'invoiceDate'" [filters]="filters" [table]="table"
                            (filterDate)="invoiceDateFilterData($event)"
                            [filterData]="invoiceDateFilterValue"></app-date-filter>
                        </th>
                     
                        <th *ngIf="isShowColumns('timesheetStartDate')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 10.5rem;" pResizableColumn>TS Start Date
                            <span pSortableColumn="timesheetStartDate" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="timesheetStartDate" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-date-filter [field]="'timesheetStartDate'" [filters]="filters" [table]="table"
                            (filterDate)="timesheetStartDateFilterData($event)"
                            [filterData]="timesheetStartDateFilterValue"></app-date-filter>
                        </th>
                        <th *ngIf="isShowColumns('timesheetEndDate')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 10rem;" pResizableColumn>TS End Date
                                <span pSortableColumn="timesheetEndDate" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                    <p-sortIcon field="timesheetEndDate" style="border-style:none !important"></p-sortIcon>
                                </span>
                                <app-date-filter [field]="'timesheetEndDate'" [filters]="filters" [table]="table"
                                (filterDate)="timesheetEndDateFilterData($event)"
                                [filterData]="timesheetEndDateFilterValue"></app-date-filter>
                            </th>
                        <th *ngIf="isShowColumns('reportStatusName')"
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 12rem;" pResizableColumn>Invoice in DVMS
                            <span  pSortableColumn="reportStatusName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="reportStatusName" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-dropdown-filter [field]="'reportStatusName'" [values]="reportStatusValues"
                            [optionLabel]="'description'" [optionValue]="'id'"[filters]="filters" [table]="table"
                                        (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                        </th>
                        <th *ngIf="isShowColumns('statusName')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>Invoice
                            Status
                            <span pSortableColumn="statusName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="statusName" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-dropdown-filter [field]="'statusName'" [values]="invoiceStatus"
                            [optionLabel]="'description'" [optionValue]="'lookupOrder'" [filters]="filters" [table]="table"
                            (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                        </th>
                       
                    <th *ngIf="isShowColumns('verifiedWithin24hrsStatus')" 
                    style="background-color: #1a90d0;color: rgb(255 255 255);width: 15rem;" pResizableColumn>Verified Within 24 Hrs
                    <span pSortableColumn="verifiedWithin24hrsStatus" style="background-color: #1a90d0;color: rgb(255 255 255);">
                        <p-sortIcon field="verifiedWithin24hrsStatus" style="border-style:none !important"></p-sortIcon>
                    </span>
                    <app-dropdown-filter [field]="'verifiedWithin24hrsStatus'" [values]="verifiedStatus"
                    [optionLabel]="'description'" [optionValue]="'lookupOrder'" [filters]="filters" [table]="table"
                    (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                </th>
                <th *ngIf="isShowColumns('verifiedOn')" 
                style="background-color: #1a90d0;color: rgb(255 255 255);width: 10.5rem;" pResizableColumn>Verified On
                <span pSortableColumn="verifiedOn" style="background-color: #1a90d0;color: rgb(255 255 255);">
                    <p-sortIcon field="verifiedOn" style="border-style:none !important"></p-sortIcon>
                </span>
                <app-date-filter [field]="'verifiedOn'" [filters]="filters" [table]="table"
                (filterDate)="verifiedOnFilterData($event)"
                [filterData]="verifiedOnFilterValue"></app-date-filter>
            </th>
                        <th *ngIf="isShowColumns('invoiceRejectReason')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>Rejection Type
                            <span pSortableColumn="invoiceRejectReason" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="invoiceRejectReason" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-dropdown-filter [field]="'invoiceRejectReason'" [values]="allInvoiceRejectReasonFilter"
                            [optionLabel]="'description'" [optionValue]="'lookupOrder'" [filters]="filters" [table]="table"
                            (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                        </th>
                        <th *ngIf="isShowColumns('rejectedByName')" 
                        style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>Rejected By 
                        <span pSortableColumn="rejectedByName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                            <p-sortIcon field="rejectedByName" style="border-style:none !important"></p-sortIcon>
                        </span>
                            <app-basic-filter [field]="'rejectedByName'" [filters]="filters" [table]="table"
                            (applyFilter)="applyFilterNew()"></app-basic-filter>
                        </th>
                        <th *ngIf="isShowColumns('approvedByName')" 
                        style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>Approved By
                        <span pSortableColumn="approvedByName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                            <p-sortIcon field="approvedByName" style="border-style:none !important"></p-sortIcon>
                        </span>
                            <app-basic-filter [field]="'approvedByName'" [filters]="filters" [table]="table"
                            (applyFilter)="applyFilterNew()"></app-basic-filter>
                        </th>
                        <th *ngIf="isShowColumns('unableProcessPaymentByName')" 
                        style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>Unable to Process<br>Payment By
                        <span pSortableColumn="unableProcessPaymentByName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                            <p-sortIcon field="unableProcessPaymentByName" style="border-style:none !important"></p-sortIcon>
                        </span>
                            <app-basic-filter [field]="'unableProcessPaymentByName'" [filters]="filters" [table]="table"
                            (applyFilter)="applyFilterNew()"></app-basic-filter>
                        </th>
                    </tr>
                    <tr>
                        <th></th>
                        <th *ngIf="isShowColumns('vendorCompanyName')">{{filters?.vendorCompanyName[0]?.value}}</th>
                        <th *ngIf="isShowColumns('applicantName')">{{filters?.applicantName[0]?.value}}</th>
                        <th *ngIf="isShowColumns('invoiceDate')">
                            <div *ngIf="invoiceDateFilterValue != undefined">
                                {{invoiceDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="invoiceDateFilterValue.length > 1">-</span> {{invoiceDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                            </div>
                        </th>
                        <th *ngIf="isShowColumns('timesheetStartDate')">
                            <div *ngIf="timesheetStartDateFilterValue != undefined">
                                {{timesheetStartDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="timesheetStartDateFilterValue.length > 1">-</span> {{timesheetStartDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                            </div>
                        </th>
                            <th *ngIf="isShowColumns('timesheetEndDate')">
                                <div *ngIf="timesheetEndDateFilterValue != undefined">
                                    {{timesheetEndDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="timesheetEndDateFilterValue.length > 1">-</span> {{timesheetEndDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                                </div>
                            </th>
                            <th *ngIf="isShowColumns('reportStatusName')">{{selectedReportStatus}}</th>
                        <th *ngIf="isShowColumns('statusName')">{{selectedStatus}}</th>
                        <th *ngIf="isShowColumns('verifiedWithin24hrsStatus')">{{selectedInvoiceVerifiedStatus}}</th>
                          
                        <th *ngIf="isShowColumns('verifiedOn')">
                            <div *ngIf="verifiedOnFilterValue != undefined">
                                {{verifiedOnFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="verifiedOnFilterValue.length > 1">-</span> {{verifiedOnFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                            </div>
                        </th>
                        
                        <th *ngIf="isShowColumns('invoiceRejectReason')">{{selectedRejectType}}</th>
                        <th *ngIf="isShowColumns('rejectedByName')">{{filters?.rejectedByName[0]?.value}}</th>
                        <th *ngIf="isShowColumns('approvedByName')">{{filters?.approvedByName[0]?.value}}</th>
                        <th *ngIf="isShowColumns('unableProcessPaymentByName')">{{filters?.unableProcessPaymentByName[0]?.value}}</th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-vendorInvoicesReportList let-rowIndex="rowIndex">
                    <tr>
                        <td style = "width: 3rem">{{rowIndex + 1}}</td>
                        <td style = "width: 11rem" *ngIf="isShowColumns('vendorCompanyName')">{{vendorInvoicesReportList.vendorCompanyName}}</td>
                        <td style = "width: 11rem" *ngIf="isShowColumns('applicantName')">{{vendorInvoicesReportList.applicantName}}</td>
                        <td style = "width: 10rem" *ngIf="isShowColumns('invoiceDate')">{{vendorInvoicesReportList.invoiceDate | date:'MM/dd/yyyy'}}</td>
                       
                        <td style = "width: 10.5rem" *ngIf="isShowColumns('timesheetStartDate')">{{vendorInvoicesReportList.timesheetStartDate | date:'MM/dd/yyyy'}}</td>
                        <td style = "width: 10rem" *ngIf="isShowColumns('timesheetEndDate')">{{vendorInvoicesReportList.timesheetEndDate | date:'MM/dd/yyyy'}}</td>
                        <td style = "width: 12rem" *ngIf="isShowColumns('reportStatusName')">
                            <span class="customer-badge status-invoice-submitted"
                            *ngIf="(vendorInvoicesReportList.reportStatusName==='Received')">Received</span>
                            <span class="customer-badge status-invoice-rejected"
                            *ngIf="(vendorInvoicesReportList.reportStatusName==='Not Received')">Not Received</span>
                        </td>
                        
                        <td style = "width: 11rem" *ngIf="isShowColumns('statusName')">
                            <span class="customer-badge status-invoice-submitted"
                                *ngIf="(vendorInvoicesReportList.statusName==='Submitted')">Submitted</span>
                            <span class="customer-badge status-invoice-withdrawn "
                                *ngIf="(vendorInvoicesReportList.statusName==='Withdrawn')">Withdrawn</span>
                            <span class="customer-badge status-invoice-approved"
                                *ngIf="(vendorInvoicesReportList.statusName==='Approved')">Approved</span>
                            <span class="customer-badge status-invoice-rejected"
                                *ngIf="(vendorInvoicesReportList.statusName==='Rejected')">Rejected</span>
                            <span class="customer-badge status-invoice-paid"
                                *ngIf="(vendorInvoicesReportList.statusName==='Paid')">Paid</span>
                            <span class="customer-badge status-invoice-unable-to-process-payment"
                                *ngIf="(vendorInvoicesReportList.statusName==='Unable To Process Payment')">Unable
                                To Process Payment </span>
                                <span class="customer-badge status-coi-expired-payment-on-hold"
                                *ngIf="(vendorInvoicesReportList.statusName==='COI Expired Payment On-Hold')">COI Expired Payment On-Hold </span>
                                <span class="customer-badge status-final-payment"
                                *ngIf="(vendorInvoicesReportList.statusName==='Final Payment')">Final Payment</span>
                                <span class="customer-badge status-final-payment"
                                *ngIf="(vendorInvoicesReportList.statusName==='Payment Scheduled')">Payment Scheduled</span>
                            <span 
                                *ngIf="(vendorInvoicesReportList.statusName==='NA')">NA</span>
                        </td>
                       
                        <td style = "width: 10rem" *ngIf="isShowColumns('verifiedWithin24hrsStatus')">{{vendorInvoicesReportList.verifiedWithin24hrsStatus}}</td>
                        <td style = "width: 10rem" *ngIf="isShowColumns('verifiedOn')">{{vendorInvoicesReportList.verifiedOn | date:'MM/dd/yyyy'}}</td>
                        <td style = "width: 11rem" *ngIf="isShowColumns('invoiceRejectReason')">
                            <span 
                                *ngIf="(vendorInvoicesReportList.statusName !=='Rejected')">NA</span>
                                <span 
                                *ngIf="(vendorInvoicesReportList.statusName ==='Rejected')"> {{vendorInvoicesReportList.invoiceRejectReason}}</span>  
                        </td>
                        <td style = "width: 11rem" *ngIf="isShowColumns('rejectedByName')">
                            <span
                            *ngIf="(vendorInvoicesReportList.rejectedByName === ' ')">NA</span>
                            <span
                            *ngIf="(vendorInvoicesReportList.rejectedByName !== ' ')">{{vendorInvoicesReportList.rejectedByName}}</span>
                        </td>
                        <td style = "width: 11rem" *ngIf="isShowColumns('approvedByName')">
                            <span
                            *ngIf="(vendorInvoicesReportList.approvedByName === ' ')">NA</span>
                            <span
                            *ngIf="(vendorInvoicesReportList.approvedByName !== ' ')">{{vendorInvoicesReportList.approvedByName}}</span>
                        </td>
                        <td style = "width: 11rem" *ngIf="isShowColumns('unableProcessPaymentByName')">
                            <span
                            *ngIf="(vendorInvoicesReportList.unableProcessPaymentByName === ' ')">NA</span>
                            <span
                            *ngIf="(vendorInvoicesReportList.unableProcessPaymentByName !== ' ')">{{vendorInvoicesReportList.unableProcessPaymentByName}}</span>
                        </td>
           
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="selectedColumns.length">No details found.</td>
                    </tr>
                  </ng-template>
            </p-table>
        </div>      
    </div>
    <!-- <br><br><br><br> -->
</section> 
